export default __webpack_public_path__ + "static/media/music-player-pic-4.ee1a0ce1.png";